import { inject, Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoService } from '@ngneat/transloco';
import { Subscription } from 'rxjs';

@Injectable()
export class TranslocoMatPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
  private readonly _translocoService = inject(TranslocoService);
  private readonly _langChangesSubscription: Subscription;

  constructor() {
    super();
    this._translateLabels();
    this._langChangesSubscription = this._translocoService.langChanges$.subscribe(() => {
      this._translateLabels();
    });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    const of = this._translocoService.translate('Paginator.Of');

    if (length === 0 || pageSize === 0) {
      return `0 ${of} ${length}`;
    }

    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    return `${startIndex + 1} - ${endIndex} ${of} ${length}`;
  };

  ngOnDestroy(): void {
    this._langChangesSubscription.unsubscribe();
  }

  private _translateLabels(): void {
    this.itemsPerPageLabel = this._translocoService.translate('Paginator.ItemsPerPage');
    this.nextPageLabel = this._translocoService.translate('Paginator.NextPage');
    this.previousPageLabel = this._translocoService.translate('Paginator.PreviousPage');
    this.firstPageLabel = this._translocoService.translate('Paginator.FirstPage');
    this.lastPageLabel = this._translocoService.translate('Paginator.LastPage');
    this.changes.next();
  }
}
